<template>
  <BaseExportContact
    :postFixer="postFixer"
    :inputRequireHighlight="inputRequireHighlight"
    :maxBuildingsPerExport="maxBuildingsPerExport"
    :selectedBuildings.sync="selectedBuildings"
  >
    <div
      slot="addtional-content"
      class="contact-category"
      :class="{'required-error-highlight': inputRequireHighlight && !workingHourChecked && !nonWorkingHourChecked}"
    >
      <label class="emphasis">{{ $t('contacts.contactCategory') }}:</label>
      <div class="category-options">
        <input
          :id="'pages-ccd-export-emergency-all'"
          type="checkbox"
          :checked="workingHourChecked && nonWorkingHourChecked"
          @change="event => updateCategory(event.target.checked)"
        >
        <label
          class="items"
          :for="'pages-ccd-export-emergency-all'"
        >
          {{ $t('all') }}
        </label>
      </div>
      <div class="category-options">
        <input
          :id="'pages-ccd-export-emergency-wh'"
          type="checkbox"
          :checked="workingHourChecked"
          @change="event => { workingHourChecked = event.target.checked }"
        >
        <label
          class="items"
          :for="'pages-ccd-export-emergency-wh'"
        >
          {{ $t('general.officeHrs') }}
        </label>
      </div>
      <div class="category-options">
        <input
          :id="'pages-ccd-export-emergency-nwh'"
          type="checkbox"
          :checked="nonWorkingHourChecked"
          @change="event => { nonWorkingHourChecked = event.target.checked }"
        >
        <label
          class="items"
          :for="'pages-ccd-export-emergency-nwh'"
        >
          {{ $t('general.afterOfficeHrs') }}
        </label>
      </div>
    </div>
  </BaseExportContact>
</template>

<script>
import { computed, getCurrentInstance } from 'vue-demi'
import { exportEmergency } from '@/api/ccdcontacts/request'
import BaseExportContact from '@/pages/ccd/BaseExportContact'
import { aclHelper, ccdPermsTypes } from '@/utils/aclHelper'

export default {
  name: 'ExportEmergency',
  components: {
    BaseExportContact,
  },
  setup () {
    const { proxy } = getCurrentInstance()
    const exportBtn = computed(() => {
      const hasAccess = aclHelper.getAccess(ccdPermsTypes.exportContact.exportEmergency)
      return hasAccess ? {
        actionTitle: 'export',
        func: proxy.exportData,
      } : {}
    })
    return {
      exportBtn,
      postFixer: 'emergency',
    }
  },
  data () {
    return {
      selectedBuildings: [],
      workingHourChecked: false,
      nonWorkingHourChecked: false,
      inputRequireHighlight: false,
      maxBuildingsPerExport: 5,
    }
  },
  methods: {
    updateCategory (checked) {
      this.workingHourChecked = checked
      this.nonWorkingHourChecked = checked
    },
    async exportData () {
      this.inputRequireHighlight = false
      if (this.selectedBuildings.length === 0 || (!this.workingHourChecked && !this.nonWorkingHourChecked)) {
        this.inputRequireHighlight = true
        return
      }

      const query = { buildingIds: this.selectedBuildings.map(building => building.id) }
      if (this.workingHourChecked) {
        query.hourAttr = 'workingHourOrder'
      }
      if (this.nonWorkingHourChecked) {
        query.hourAttr = query.hourAttr ? undefined : 'nonWorkingHourOrder'
      }
      await exportEmergency(query)
    },
  },
}
</script>

<style lang="scss" scoped>
.category-options {
    width: 250px;
    input[type="checkbox"] {
      margin: 0;
    }
    label {
      margin-top: 0;
    }
}
</style>
